import React from 'react';
import { TextInput } from '../../form/TextInput';
import { PhoneNumberInput } from '../../form/PhoneNumberInput';
import * as Grid from '../../components/Grid';
export const ContactFields = ({ contact, onChange, errors, }) => {
    return (React.createElement(React.Fragment, null,
        React.createElement("h3", null, "Contact Info"),
        React.createElement(TextInput, { label: "Name", id: "contact_name", required: true, errors: errors, value: contact.name, onChange: (v) => onChange('name', v) }),
        React.createElement(Grid.Row, null,
            React.createElement(Grid.Column, { width: 6 },
                React.createElement(PhoneNumberInput, { label: "Phone", id: "contact_phone", required: true, errors: errors, value: contact.phone, onChange: (v) => onChange('phone', v) })),
            React.createElement(Grid.Column, { width: 6 },
                React.createElement(TextInput, { label: "Email", id: "contact_email_address", required: true, errors: errors, value: contact.email_address, onChange: (v) => onChange('email_address', v) })))));
};
